export const convertNumberToWord = function (number) {
  const numberWords = {
    0: "ZERO",
    1: "ONE",
    2: "TWO",
    3: "THREE",
    4: "FOUR",
    5: "FIVE",
    6: "SIX",
    7: "SEVEN",
    8: "EIGHT",
    9: "NINE",
  };

  if (typeof number === "number" && number >= 0 && number <= 9) {
    return numberWords[number];
  }
};
